/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkUpdateDivisionLayoutsRequest } from '../../models/bulk-update-division-layouts-request';

export interface ApiIdpSubmissionsDirectDivisionLayoutsPut$Params {
      body?: Array<BulkUpdateDivisionLayoutsRequest>
}

export function apiIdpSubmissionsDirectDivisionLayoutsPut(http: HttpClient, rootUrl: string, params?: ApiIdpSubmissionsDirectDivisionLayoutsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiIdpSubmissionsDirectDivisionLayoutsPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiIdpSubmissionsDirectDivisionLayoutsPut.PATH = '/api/idp/submissions-direct/division-layouts';
